import React from 'react';
import AWS from 'aws-sdk';
import {
  Button as LumosButton
 } from "@loanpal/lumos__core";

const ExportDynamoDBTable = ({ tableName }) => {
  const handleExport = async () => {
    try {
      // Configure AWS credentials
      // CAUTION: DO NOT COMIT THE AWS KEYS
      AWS.config.update({
        accessKeyId: '',
        secretAccessKey: '',
        region: 'us-west-2',
      });

      // Create a DynamoDB instance
      const dynamodb = new AWS.DynamoDB();

      // Scan the DynamoDB table with pagination (DynamoDB returns at most ~1MB per scan)
      const items = [];
      let lastEvaluatedKey = null;

      do {
        const scanParams = {
          TableName: tableName,
          ...(lastEvaluatedKey && { ExclusiveStartKey: lastEvaluatedKey }),
        };
        const scanResult = await dynamodb.scan(scanParams).promise();
        const page = (scanResult.Items || []).map((item) =>
          AWS.DynamoDB.Converter.unmarshall(item)
        );
        items.push(...page);
        lastEvaluatedKey = scanResult.LastEvaluatedKey || null;
      } while (lastEvaluatedKey);

      // Flatten nested objects for CSV (e.g. submittingUser -> submittingUser.email, submittingUser.firstName)
      const flattenForCsv = (obj, prefix = '') => {
        const row = {};
        if (obj == null || typeof obj !== 'object') return row;
        Object.keys(obj).forEach((key) => {
          if (key === '__typename') return;
          const val = obj[key];
          const col = prefix ? `${prefix}.${key}` : key;
          if (val != null && typeof val === 'object' && !Array.isArray(val) && !(val instanceof Date)) {
            Object.assign(row, flattenForCsv(val, col));
          } else {
            row[col] = Array.isArray(val) ? JSON.stringify(val) : val;
          }
        });
        return row;
      };

      const flatItems = items.map((item) => flattenForCsv(item));

      // Collect all headers from all rows and sort for stable column order
      const allKeys = new Set();
      flatItems.forEach((row) => Object.keys(row).forEach((k) => allKeys.add(k)));
      let headers = [...allKeys].sort();

      if (tableName && tableName.startsWith('Requests-')) {
        headers = headers.filter((h) => h !== 'notes' && h !== 'requestNotes');
      }

      const escapeCsv = (val) => {
        const s = val == null ? '' : String(val);
        if (/[,"\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
        return s;
      };

      let csvContent = '';
      if (headers.length > 0) {
        csvContent += headers.map(escapeCsv).join(',') + '\n';
        flatItems.forEach((row) => {
          csvContent += headers.map((h) => escapeCsv(row[h])).join(',') + '\n';
        });
      }

      // Create a temporary anchor element to download the CSV
      const downloadAnchor = document.createElement('a');
      downloadAnchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
      downloadAnchor.download = `${tableName}.csv`;
      document.body.appendChild(downloadAnchor);

      // Trigger the click event to download the file
      downloadAnchor.click();

      // Cleanup
      document.body.removeChild(downloadAnchor);
    } catch (error) {
      console.error('Error exporting DynamoDB table:', error);
    }
  };

  return (
    <div>
      <LumosButton onClick={handleExport}>Export QuickLinks</LumosButton>
    </div>
  );
};

export default ExportDynamoDBTable;
